import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { TranslatorContext } from "../context/Translator";
import { SidebarContext } from "../context/Sidebar";
import sidenavs from "../assets/data/sidenavs.json";
import { APP_PREFIX_PATH } from "../constant/constant";

// Import Material-UI icons
import AddHomeWorkRoundedIcon from '@mui/icons-material/AddHomeWorkRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CellTowerIcon from '@mui/icons-material/CellTower';
import EventIcon from '@mui/icons-material/Event';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import AddCardIcon from '@mui/icons-material/AddCard';
import DifferenceIcon from '@mui/icons-material/Difference';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
// Add other relevant icons

export default function SidebarLayout() {
    const { t, n, currentLanguage } = useContext(TranslatorContext);
    const { sidebar } = useContext(SidebarContext);

    const handleDropdown = (event) => {
        const buttonElement = event.currentTarget;
        const itemElement = buttonElement.parentElement;
        const isActive = itemElement.classList.contains('active');
        const allItems = document.querySelectorAll('.mc-sidebar-menu-item');
        const allDropdowns = document.querySelectorAll('.mc-sidebar-dropdown-list');
        const dropdownElement = itemElement.querySelector('.mc-sidebar-dropdown-list');


        if (isActive) {
            itemElement.classList.remove('active');
            dropdownElement.style.height = "0px";
        } else {
            allItems.forEach(item => item.classList.remove('active'));
            allDropdowns.forEach(dropdown => dropdown.style.height = "0px");

            itemElement.classList.add('active');
            dropdownElement.style.height = dropdownElement.scrollHeight + "px";
        }
    };

    const renderSubMenus = (submenus) => {
        return (
            <ul className="mc-sidebar-dropdown-list">
                {submenus.map((submenu, submenusIndex) => (
                    <li key={submenusIndex} className="mc-sidebar-dropdown-item">
                        {submenu.subSubmenus ? (
                            <>
                                <button
                                    type="button"
                                    className="mc-sidebar-menu-btn"
                                    onClick={handleDropdown}
                                >
                                    <span>{t(submenu.text)}</span>
                                    {currentLanguage?.dir === "ltr" ? (
                                        <small className="material-icons right">
                                            chevron_right
                                        </small>
                                    ) : (
                                        <small className="material-icons left">
                                            chevron_left
                                        </small>
                                    )}
                                </button>
                                {renderSubMenus(submenu.subSubmenus)}
                            </>
                        ) : (
                            <Link
                                to={`${APP_PREFIX_PATH}${submenu.path}`}
                                className="mc-sidebar-dropdown-link"
                            >
                                {t(submenu.text)}
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        );
    };


    // Map of string icon names to actual Material-UI icon components
    const iconMap = {

        AddHomeWorkRoundedIcon: AddHomeWorkRoundedIcon,
        AccountCircle: AccountCircleIcon,
        DashboardIcon: DashboardIcon,
        GroupIcon: GroupIcon,
        GroupAddIcon: GroupAddIcon,
        FormatListBulletedIcon: FormatListBulletedIcon,
        EditCalendarIcon: EditCalendarIcon,
        AccountBalanceWalletIcon: AccountBalanceWalletIcon,
        AssignmentIcon: AssignmentIcon,
        CellTowerIcon: CellTowerIcon,
        EventIcon: EventIcon,
        LibraryBooksIcon: LibraryBooksIcon,
        EqualizerIcon: EqualizerIcon,
        AddCardIcon: AddCardIcon,
        DifferenceIcon: DifferenceIcon,
        PermPhoneMsgIcon: PermPhoneMsgIcon,
        AccountBalanceIcon:AccountBalanceIcon

    };

    return (
        <aside className={`mc-sidebar thin-scrolling ${sidebar && "active"}`}>
            {sidenavs?.map((sidenav, sidenavIndex) => (
                <menu key={sidenavIndex} className="mc-sidebar-menu">
                    <h5 className="mc-sidebar-menu-title">{t(sidenav.title)}</h5>
                    <ul className="mc-sidebar-menu-list">
                        {sidenav.menus.map((menu, menuIndex) => {

                            const IconComponent = iconMap[menu.icon];

                            return (
                                <li key={menuIndex} className="mc-sidebar-menu-item">
                                    {menu.submenus ? (
                                        <>
                                            <button
                                                type="button"
                                                className="mc-sidebar-menu-btn"
                                                onClick={handleDropdown}
                                            >
                                                {IconComponent && <IconComponent />} {/* Render the icon component */}
                                                <span>{t(menu.text)}</span>
                                                {menu.badge?.text && (
                                                    <sup className={menu.badge.variant}>
                                                        {t(menu.badge.text)}
                                                    </sup>
                                                )}
                                                {menu.badge?.count && (
                                                    <sup className={menu.badge.variant}>
                                                        {n(menu.badge.count)}
                                                    </sup>
                                                )}
                                                {currentLanguage?.dir === "ltr" ? (
                                                    <small className="material-icons right">
                                                        chevron_right
                                                    </small>
                                                ) : (
                                                    <small className="material-icons left">
                                                        chevron_left
                                                    </small>
                                                )}
                                            </button>

                                            <ul className="mc-sidebar-dropdown-list">
                                                {menu.submenus.map((submenu, submenusIndex) => (
                                                    <li
                                                        key={submenusIndex}
                                                        className="mc-sidebar-dropdown-item"
                                                    >
                                                        <Link
                                                            to={`${APP_PREFIX_PATH}${submenu.path}`}
                                                            className="mc-sidebar-dropdown-link"
                                                        >
                                                            {t(submenu.text)}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <Link
                                            to={`${APP_PREFIX_PATH}${menu.path}`}
                                            className="mc-sidebar-menu-btn"
                                        >
                                            {IconComponent && <IconComponent />} {/* Render the icon component */}
                                            <span>{t(menu.text)}</span>
                                            {menu.badge?.count && (
                                                <sup className={menu.badge.variant}>
                                                    {n(menu.badge.count)}
                                                </sup>
                                            )}
                                            {menu.badge?.text && (
                                                <sup className={menu.badge.variant}>
                                                    {t(menu.badge.text)}
                                                </sup>
                                            )}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </menu>
            ))}
        </aside>
    );
}
